var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"overline"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.reference))]),_c('span',[_vm._v("— "+_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }